export const DEMOGRAPHICS_QUESTIONNAIRE_IDENTIFIER =
  'demographics-questionnaire-v1';
